<template>
  <div>
    <web-header></web-header>
    <div>
      <router-view></router-view>
    </div>
    <web-footer></web-footer>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import WebHeader from './WebHeader.vue'
  import WebFooter from './WebFooter.vue'
  export default {
    data () {
      return {}
    },
    components: {WebHeader, WebFooter},
    computed: mapState({})
  }
</script>

<style>
  @import "../../assets/css/web_base.css";
</style>



// WEBPACK FOOTER //
// WebIndex.vue?e65d9ab8